import React from "react";
import { SiMaterialdesign } from "react-icons/si";
import "./whyus.css";
import middleImg from "../../Media/middlepic.png";
import { Link } from "react-router";
import { GoGoal } from "react-icons/go";
import { FaBullseye } from "react-icons/fa";

export default function WhyUs() {
  return (
    <div className="whyus">
      <div className="whyus-top">
        <div className="top-left">
          <h6 className="small-header">Who we are</h6>
          <h3>
            Each Zakarry piece is crafted with care, designed to celebrate the
            wearer, and made to honor the craft.
          </h3>
        </div>

        <div className="top-right">
          <p>
            At Zakarry, every design is a collaboration. Our brand is a fusion
            of precision tailoring and purpose-driven vision. While the hands
            behind the dresses bring the artistry, the mind behind the brand
            drives the experience; overseeing styling, communications, and the
            relationship with every client we serve. We don’t believe in rushing
            trends. We believe in lasting impressions.
          </p>
          <Link to="/booking">
            <button>BOOK AN APPOINTMENT</button>
          </Link>
        </div>
      </div>

      <div className="whyus-down">
        <div className="down-left">
          <div className="reason">
            <GoGoal />
            <h3>Our Mission</h3>
            <p>
              To design meaningful, handcrafted pieces that celebrate
              individuality, elevate confidence, and reflect timeless beauty;
              one garment at a time. We are committed to quality, intentional
              design, and a personalized experience that makes every client feel
              seen, valued, and empowered.
            </p>
          </div>
          {/* <div className="reason">
            <SiMaterialdesign />
            <h3>Personalized Design</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
              tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </p>
          </div> */}
        </div>
        <div className="down-right">
          <div className="reason">
           <FaBullseye />
            <h3>Our Vision</h3>
            <p>
              To become a globally recognized fashion house known for its
              craftsmanship, storytelling, and authenticity; inspiring women
              across generations to wear their truth with elegance and pride.
            </p>
          </div>
          {/* <div className="reason">
            <SiMaterialdesign />
            <h3>Personalized Design</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
              tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </p>
          </div> */}
        </div>
      </div>
      <img className="middle-img" src={middleImg} alt="" loading="lazy" decoding="async" />
    </div>
  );
}
